import { useEffect, useState } from "react";
import ReactGA from "react-ga";
import moment from "moment";
import { useDispatch } from "react-redux";
import { setTrackEvent, resetTrackEvent } from "../store/analytics";
import apiService from "../api/api.service";

const usePageViews = (shop) => {
  const [trackingId, setTrackingId] = useState("");
  const dispatch = useDispatch();
  let location = window.location.pathname;
  useEffect(() => {
    if (window.dynamicReview) return;
    const getTracking = async () => {
      try {
        const { data } = await apiService.get("getGaTrackingId", {
          shop: shop,
        });
        setTrackingId(data.ga_tracking_id);
        return data;
      } catch (err) {
        // console.log(err);
      }
    };

    getTracking();

    ReactGA.initialize([
      {
        trackingId: trackingId,
        debug: false,
        gaOptions: { cookieDomain: "auto" },
      },
    ]);
    location === `${process.env.REACT_APP_PATH}` && ReactGA.pageview(location);
    dispatch(
      setTrackEvent({
        category: "page_view",
        created_at: moment(Date.now()).unix(),
      })
    );
    return () => {
      dispatch(resetTrackEvent());
    };
  }, [location, dispatch, shop, trackingId]);

  return null;
};

export default usePageViews;
